export const getList = (strings, max) => {
    if (strings.length === 0)
        return '';
    if (max === 0) {
        return `${strings.length} items`;
    }
    if (strings.length === 1) {
        return strings[0];
    }
    if (max !== undefined && strings.length > max) {
        const sliced = strings.slice(0, max);
        return sliced.join(', ') + `, +${strings.length - max} more`;
    }
    return strings.join(', ');
};
